export function normalizeInviterUsername(username) {
  return String(username || '').trim().toLowerCase();
}

export function normalizeInviteDigits(digits) {
  const digitsOnly = String(digits || '').trim().replace(/\D/g, '');
  if (!digitsOnly) return '';
  return digitsOnly.padStart(3, '0').slice(-3);
}

export function buildInviteCode(inviterUsername, digits) {
  const normalizedUsername = normalizeInviterUsername(inviterUsername);
  const normalizedDigits = normalizeInviteDigits(digits);
  if (!normalizedUsername || !normalizedDigits) return '';
  return `${normalizedUsername}-${normalizedDigits}`;
}

export function parseInviteCode(inviteCode) {
  const trimmed = String(inviteCode || '').trim();
  const match = trimmed.match(/^(.+)-(\d{3})$/i);
  if (!match) return null;
  return {
    inviterUsername: normalizeInviterUsername(match[1]),
    inviteDigits: normalizeInviteDigits(match[2]),
  };
}

export function parseInviteFromSearchParams(searchParams) {
  const inviter = searchParams.get('inviter');
  const code = searchParams.get('code');
  if (inviter && code) {
    return {
      inviterUsername: inviter,
      inviteDigits: code,
    };
  }

  const legacyInvite = searchParams.get('invite');
  if (legacyInvite) {
    return parseInviteCode(legacyInvite);
  }

  return null;
}

export function buildInviteUrl(basePath, inviterUsername, inviteDigits) {
  const url = new URL(basePath, window.location.origin);
  url.searchParams.set('inviter', normalizeInviterUsername(inviterUsername));
  url.searchParams.set('code', normalizeInviteDigits(inviteDigits));
  return `${url.pathname}${url.search}`;
}
